export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoiZmlzaGJyYWluLWRldiIsImEiOiJjazN6dnp2cXEwenluM2pzOHI4N2E1aGdkIn0.v3eqQyyUIgVCmZrIQ7kj9g';
export const ADJUST_LINK = 'https://fishbrain.go.link';

const ENVIRONMENT =
  import.meta.env.VITE_FISHBRAIN_ENV ?? (import.meta.env.PROD ? 'prod' : 'staging');
const isProdEnvironment = ENVIRONMENT === 'prod';

export const TILES_URL = isProdEnvironment
  ? 'https://tiles.fishbrain.com'
  : 'https://tiles.staging.fishbrain.com';
export const RUTILUS_URL = isProdEnvironment
  ? 'https://rutilus.fishbrain.com'
  : 'https://rutilus.staging.fishbrain.com';
export const TAKE_ME_FISHING_URL = import.meta.env.PROD
  ? 'https://www.takemefishing.org'
  : 'https://tmfstage.azurewebsites.net';

export const SENTRY_DSN =
  'https://9dd22b7b675302271cdc546e28c8105a@o4510677991292928.ingest.de.sentry.io/4511091777732688';
